import React from 'react';
import styled from 'styled-components';
import calculateDiscount from '../../Cart/utils/calculateDiscout';
import {Body, Headline} from '../../../components/Typography';
import appConfig from '../../../../app-config';
import numeral from 'numeral';

const Wrapper = styled.div`
  width: 240px;
  display: grid;
  grid-gap: 16px;
`;

const LineItemRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const LineItem = styled(Body)`
  text-transform: capitalize;
`;

const Total = styled(Headline)`
  text-transform: uppercase;
`;

const Receipt = ({orderSummary, is_tip_enabled}) => {
  return (
    <Wrapper>
      <LineItemRow>
        <LineItem id="Receipt-Subtotal">Subtotal</LineItem>
        <LineItem>{numeral(orderSummary.subtotal).format('$0.00')}</LineItem>
      </LineItemRow>
      <LineItemRow>
        <LineItem id="Receipt-Discount">Discount</LineItem>
        <LineItem>
          {numeral(orderSummary.total_credit_applied * -1).format('$0.00')}
        </LineItem>
      </LineItemRow>
      {is_tip_enabled && (
        <LineItemRow>
          <LineItem id="Receipt-Tip">Tip</LineItem>
          <LineItem>{numeral(orderSummary.tip).format('$0.00')}</LineItem>
        </LineItemRow>
      )}
      {orderSummary.serviceFees && orderSummary.serviceFees.length > 0
        ? orderSummary.serviceFees.map((serviceFee, i) => (
            <LineItemRow key={i}>
              <LineItem id={`PriceBreakDown-${serviceFee.display_name}`}>
                {serviceFee.display_name}
              </LineItem>
              <LineItem
                style={{textAlign: 'right'}}
                id={`PriceBreakDown-${serviceFee.display_name}-Amount`}
              >
                {numeral(serviceFee.amount).format('$0.00')}
              </LineItem>
            </LineItemRow>
          ))
        : null}
      {/* {orderSummary.orderMethodType === 'delivery' && (
        <LineItemRow>
          <LineItem id="Receipt-DeliveryFee">Delivery Fee</LineItem>
          <LineItem>{numeral(orderSummary.fees).format('$0.00')}</LineItem>
        </LineItemRow>
      )} */}
      <LineItemRow>
        <LineItem id="Receipt-Tax">Tax</LineItem>
        <LineItem>{numeral(orderSummary.tax).format('$0.00')}</LineItem>
      </LineItemRow>
      <LineItemRow style={{marginTop: '4px'}}>
        <Total id="Receipt-Total">Total</Total>
        <Total>{numeral(orderSummary.total).format('$0.00')}</Total>
      </LineItemRow>
      {orderSummary.currency && (
        <div style={{textAlign: 'right'}}>
          {`All prices are in ${orderSummary.currency}`}
        </div>
      )}
    </Wrapper>
  );
};

export default Receipt;
